export function nextRouterMode({ isRouter, requestedMode = null, currentMode = null }) {
  if (!isRouter) return null
  return requestedMode || currentMode || "simple"
}
